import Filter from "./filter"
import Product from "./product"

const Shop = () => {
    return (<>
        <Filter />
        <Product />
    </>)
}
export default Shop